import { Button, Col, Icon, Input, Popover, Row, Tooltip } from 'antd';
import React, { useState } from 'react';
import PhoneRecords from '../../../../../../../../components/PhoneRecords/PhoneRecords';
import PhoneNumber from '../../../../../../../../components/PhoneNumber/PhoneNumber';
import { useDispatch, useSelector } from 'react-redux';
import { requestListActions } from '../../../../../../request-list.actions';

const statusIds = {
  new: 1,
  inWork: 2,
  closed: 3,
  cancelled: 4,
  done: 5,
  doneCallHuman: 6,
};

const noEditableStatusIds = new Set([statusIds.closed, statusIds.cancelled]);

const areCanChange = (request) => !noEditableStatusIds.has(request.statusId);

const ExpandedTableRow = ({ record, index, indent, expanded }) => {
  const dispatch = useDispatch();

  const canChangeDescription = useSelector(
    (state) => state.authentication.userInfo.CanChangeDescription
  );

  const [descriptionPanelValue, setDescriptionPanelValue] = useState('');
  const [descriptionPanelVisible, setDescriptionPanelVisible] = useState(false);

  const canChange = areCanChange(record);
  const canChangeDesc = canChange && canChangeDescription;

  const handleDescriptionPanelChange = (v) => {
    setDescriptionPanelValue(v.target.value);
  };

  const handleDescriptionPanelCancel = () => {
    setDescriptionPanelVisible(false);
    setDescriptionPanelValue('');
  };

  const handleDescriptionPanelOk = () => {
    if (descriptionPanelValue) {
      dispatch(
        requestListActions.setRequestDescription(
          record.id,
          descriptionPanelValue
        )
      );
    }

    handleDescriptionPanelCancel();
  };

  const handleDescriptionPanelVisibleChange = (des, visible) => {
    setDescriptionPanelVisible(visible);
    setDescriptionPanelValue(visible ? des : '');
  };

  const handleBindCallToRequestSuccess = (requestId) => {
    dispatch(requestListActions.setRequestHasRecord(requestId));
  };

  const DescriptionPanel = (
    <div style={{ textAlign: 'right', width: '360px' }}>
      <Input.TextArea
        onChange={handleDescriptionPanelChange}
        value={descriptionPanelValue}
        type="textarea"
        autosize={{ minRows: 2, maxRows: 5 }}
        style={{ marginBottom: '10px' }}
      />
      <Button
        onClick={handleDescriptionPanelCancel}
        style={{ marginRight: '10px' }}
      >
        Отмена
      </Button>
      <Button
        onClick={handleDescriptionPanelOk}
        type="primary"
      >
        OK
      </Button>
    </div>
  );

  const bcl = '';

  return (
    <div
      id={'dspxExRow' + record.id}
      className={`dspx-query-detail ${bcl}`}
      style={{
        padding: '0px 8px 10px 30px',
      }}
    >
      <Row gutter={16}>
        <Col span={1}>
          <PhoneRecords
            hasRecord={record.hasRecord}
            requestId={record.id}
            onBindCallSuccess={() => handleBindCallToRequestSuccess(record?.id)}
          />
        </Col>

        <Col span={7}>
          {record.contactPhones && (
            <div>
              <Icon
                type="phone"
                style={{ marginRight: '4px' }}
              />
              <PhoneNumber
                phoneNumber={record.contactPhones}
                name={record.clientName}
              />
              {record.clientName && (
                <Icon
                  type="user"
                  style={{ marginRight: '4px', marginLeft: '8px' }}
                />
              )}
              {record.clientName}
            </div>
          )}

          <div>
            <Icon
              type="file-text"
              style={{ marginRight: '4px' }}
            />
            {record.service} : {record.description}
            {true && (
              <Popover
                placement="rightTop"
                autoAdjustOverflow={false}
                content={DescriptionPanel}
                title={
                  <div style={{ color: '#0995ed', fontSize: 18 }}>
                    <Icon type="file-text" />
                    <span>Описание</span>
                  </div>
                }
                trigger="click"
                visible={descriptionPanelVisible}
                onVisibleChange={(visible) => {
                  handleDescriptionPanelVisibleChange(
                    record.description,
                    visible
                  );
                }}
              >
                <Tooltip
                  mouseLeaveDelay={0}
                  title="Редактировать описание"
                >
                  <Button
                    ghost
                    size="small"
                    shape="circle"
                    style={{ marginLeft: 2, fontSize: '10px' }}
                  >
                    <Icon
                      type="edit"
                      style={{ margin: 0 }}
                    />
                  </Button>
                </Tooltip>
              </Popover>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ExpandedTableRow;
